import { AppButton } from 'src/component/common/analog/molecule/button/AppButton'

type EditModeButtonsProps = {
  isEditMode: boolean
  onEdit: () => void
  onCancel: () => void
  onSave: () => void
  editButtonLabel: string
  cancelButtonLabel: string
  saveAllButtonLabel: string
}

/**
 * Reusable component for edit/cancel/save buttons
 */
export function EditModeButtons(props: EditModeButtonsProps) {
  const { isEditMode, onEdit, onCancel, onSave, editButtonLabel, cancelButtonLabel, saveAllButtonLabel } = props

  return (
    <>
      {isEditMode ? (
        <>
          <AppButton fontSize={12} variant="light" onClick={onCancel}>
            {cancelButtonLabel}
          </AppButton>
          <AppButton fontSize={12} variant="contained" onClick={onSave}>
            {saveAllButtonLabel}
          </AppButton>
        </>
      ) : (
        <AppButton fontSize={12} variant="dark" onClick={onEdit}>
          {editButtonLabel}
        </AppButton>
      )}
    </>
  )
}
